import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "py-2 px-4 grid justify-items-center lg:flex lg:flex-wrap lg:items-center" }
const _hoisted_3 = { class: "w-full relative flex justify-between px-4" }
const _hoisted_4 = { class: "text-md font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap uppercase text-black" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "block h-4 w-4 fill-current",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" })
  ])
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "flex flex-col items-center lg:flex-row list-none ml-auto" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex flex-col items-center lg:flex-row list-none ml-auto" }
const _hoisted_11 = { class: "nav-item m-1" }
const _hoisted_12 = { class: "px-3 py-1 flex items-center text-xs uppercase font-bold leading-snug hover:opacity-75" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "text-lg leading-lg opacity-75" }, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex flex-col items-center list-none ml-auto" }
const _hoisted_16 = { class: "nav-item m-1" }
const _hoisted_17 = { class: "px-3 py-1 flex items-center text-xs uppercase font-bold leading-snug hover:opacity-75" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "text-lg leading-lg opacity-75" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "text-lg leading-lg opacity-75" }, null, -1)

import { ref } from 'vue'
  import { storeToRefs, getActivePinia } from 'pinia'
  import { useUserStore } from '@/stores/UserStore'
  import { useRouter } from 'vue-router'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

  const {logout } = useUserStore()
  const router = useRouter()
  const {userFirstName, userId, userLastName, userPhoneNumber, userEmail} = storeToRefs(useUserStore())

  let showMenu= ref(false)

  function toggleNavbar(){
    showMenu.value = !showMenu.value;
  }

  function hideNavbar(){
      showMenu.value = false;
  }

  function signOut(){
    logout();
    toggleNavbar()
    router.push("/");
  }


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            onClick: hideNavbar
          }, {
            default: _withCtx(() => [
              _createTextVNode("Happening Hour")
            ]),
            _: 1
          })
        ]),
        _hoisted_5,
        _createElementVNode("button", {
          class: "cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block outline-none focus:outline-none",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleNavbar()))
        }, _hoisted_7)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{'hidden': !_unref(showMenu), 'flex': _unref(showMenu)}, "lg:flex-grow items-center"])
      }, [
        _createElementVNode("ul", _hoisted_8, [
          (_unref(userId) === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", _hoisted_11, [
                    _createElementVNode("a", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_router_link, {
                        to: "/login",
                        onClick: toggleNavbar
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Se connecter")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(userId) !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("ul", _hoisted_15, [
                  _createElementVNode("li", _hoisted_16, [
                    _createElementVNode("a", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_router_link, {
                        to: '/user/'+ _unref(userId),
                        onClick: toggleNavbar
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Mon Compte")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]),
                  _createElementVNode("li", { class: "nav-item m-1" }, [
                    _createElementVNode("a", { class: "px-3 py-1 flex items-center text-xs uppercase font-bold leading-snug hover:opacity-75" }, [
                      _hoisted_19,
                      _createElementVNode("div", {
                        class: "cursor-pointer",
                        onClick: signOut
                      }, "Deconnexion ")
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}
}

})